import React, { useContext, useEffect } from "react"
import { graphql, Link } from "gatsby"
import styled, { withTheme } from "styled-components"
import { BLOCKS } from "@contentful/rich-text-types"
import { MARKS } from "@contentful/rich-text-types"
import { INLINES } from '@contentful/rich-text-types'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../components/layout/layout"
import Container, { Half, Quarter, Row, ThreeQuarter } from "../components/layout/container"
import SEO from "../components/seo/seo"
import PostCarousel from "../components/ui/post-carousel"
import List from "../components/ui/list"
import LinkIcon from "../images/link.svg"
import TraderCarousel from "../components/ui/trader-carousel"


const Section = styled.section`
  background: ${(props) => props.theme.colors.white};
  padding: 3rem 0 3rem;
  h2 {
    //font-family: ${(props) => props.theme.fontBold};
    position: relative;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  h1 {
      font-family: ${(props) => props.theme.fontGreen};
      letter-spacing: 0.05rem;
      text-transform: uppercase;
      font-size 3.5rem;
      margin: 0;
      padding-bottom: 2rem;
  }
  aside {
    display: none;
    .future {
        opacity: 1;
    }
    .proposal {
        opacity: 0.5;
    }
    .collab {
        opacity: 0.5;
    }
    .about {
        opacity: 0.5;
    }
    .feedback {
        opacity: 0.5;
    }
    @media screen and (min-width: ${props => props.theme.breakpoints.tablet}) {
      display: block;
    }
  }
`;

const Back = styled.div`
  cursor: pointer;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-family: "Pharma Bold Condensed",sans-serif;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    padding: 0.5rem 0 0.5rem;
    margin-right: 6rem;
    a {
      text-decoration: none;
    }
    border-bottom: 3px solid ${props => props.theme.colors.primary};
    @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
      border-bottom: 1px solid ${props => props.theme.colors.primary};
      margin-right: 0;
      margin-bottom: 2rem;
    }
    .arrow-left {
      position: relative;
      top: 5px;
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 12px solid ${props => props.theme.colors.primary};
      margin-right: 2rem;
    }
`;

const OpeningTimes = styled.ul`
    display: inline-block;
    list-style: none;
    margin: 0;
    padding: 0;
    margin-left: 1rem;
    @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
      display: none;
    }
    li {
        :first-child {
          font-family: ${(props) => props.theme.fontGreen};
          letter-spacing: 0.05rem;
          text-transform: uppercase;
        }
        list-style: none;
         &:last-child {
          font-family: ${(props) => props.theme.fontCondensed};
        }
    }
`

const OpeningTimesMobile = styled.ul`
    display: inline-block;
    list-style: none;
    margin: 0;
    padding: 0;
    display: none;
    @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
      display: block;
    }
    li {
        :first-child {
          font-family: ${(props) => props.theme.fontGreen};
          letter-spacing: 0.05rem;
          text-transform: uppercase;
        }
        list-style: none;
         &:last-child {
          font-family: ${(props) => props.theme.fontCondensed};
        }
    }
`
const Content = styled.div`
    margin: 2rem 0 3rem;
    img {
      width: 100%;
    }
`
const Contacts = styled.div`
    background-color: #EED0C7;
    padding: 2rem;
    margin-top: 2rem;
    span {
        font-size 0.6rem;
        margin-bottom: 1rem;
        display: block;
    }
    .left {
        padding-right: 1.5rem;
        @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
          margin-bottom: 2rem;
        }
    }
    .right {
        padding-left: 1.5rem;
        @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
          padding-left: 0;
        }
    }
    
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        
        li {
            svg {
                padding-left: 1rem;
                top: 3px;
                position: relative;
            }
            display: flex;
            font-family: ${(props) => props.theme.fontCondensed};
            flex-direction: row;
            justify-content: space-between;
            padding: 0.5rem 0 0.5rem;
            margin: 0;
            border-bottom: 2px solid ${props => props.theme.colors.primary};
        }
    }
`




export const query = graphql`
         query($slug: String!) {
           contentfulTrader(slug: { eq: $slug }) {
               slug
             traderTitle
             
             traderMetaDescription {
                traderMetaDescription
              }
             traderCategory
             traderNumber
             openingTimes {
                openingTimes
                }
             phone
             facebook
             instagram
             website
             traderCoverImage {
               gatsbyImageData(
                  width: 500
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
             }
            traderImageGallery {
              id
              gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
            }
             body {
               raw
               references {
                    ... on ContentfulAsset {
                        title
                        description
                        contentful_id
                        __typename
                        fixed(width: 800) {
                            width
                            height
                            src
                            srcSet
                        }
                    }
                }
             }
           }
         }
       `;

const options: any = {
  renderMark: {
    [MARKS.CODE]: (embedded: any) => (
      <div dangerouslySetInnerHTML={{ __html: embedded }} />
    ),
  },
  renderNode: {
    "embedded-asset-block": (node) => {
      //const alt = node.data.target.fields.title["en-GB"];
      const url = node.data.target.fixed.src;
      return <img src={url} />;
    },
    [INLINES.HYPERLINK]: (node) => {
      return <a href={node.data.uri} target="_blank" rel="noopener noreferrer">{node.content[0].value}</a>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: (_node: any) => {
        const entry = _node.data.target

        if (
          entry.sys.type === "Entry" &&
          entry.sys.contentType.sys.id === "traderListHolder"
        ) {
          return (
            <List>
              
            </List>
          )
        } else if (
          entry.sys.type === "Entry" &&
          entry.sys.contentType.sys.id !== "smallPrint"
        ) {
          return entry.fields.text["en-GB"].content.map((c: any, i: number) => (
            <p key={i}>
              <Small>{c.content.map((text: any) => text.value)}</Small>
            </p>
          ))
        }
      },

  },
};

const TraderPost = (props) => {
  

  const featuredImage = getImage(props.data.contentfulTrader.traderCoverImage)
  const galleryImages = getImage(props.data.contentfulTrader.traderImageGallery)
  console.log(props.data.contentfulTrader.traderImageGallery);
  console.log(featuredImage);
//   var fixedOG = "https:" + props.data.contentfulTrader.traderCoverImage.file.url;

//check for empty link fields
  if (props.data.contentfulTrader.facebook === null) {
    var facebookTrue = false;
  }
  else if (props.data.contentfulTrader.facebook != null) {
    var facebookTrue = true;
  }

    if (props.data.contentfulTrader.instagram === null) {
    var instagramTrue = false;
  }
  else if (props.data.contentfulTrader.instagram != null) {
    var instagramTrue = true;
  }


  if (props.data.contentfulTrader.website === null) {
    var websiteTrue = false;
  }
  else if (props.data.contentfulTrader.website != null) {
    var websiteTrue = true;
  }

  if (props.data.contentfulTrader.traderImageGallery === null) {
    var traderImageGalleryTrue = false;
  }
  else if (props.data.contentfulTrader.traderImageGallery != null) {
    var traderImageGalleryTrue = true;
  }

  return (
    <Layout>
        <Section id="trader-post">
          <Container>
            <SEO
              title={props.data.contentfulTrader.traderTitle}
              description={props.data.contentfulTrader.traderMetaDescription.traderMetaDescription}
            //   image={fixedOG}
            />
            <Row>
                <Quarter>
                    <Back>
                        <div className="arrow-left"></div>
                        <Link to="/trader-directory/">Back</Link>
                    </Back>
                </Quarter>
                <ThreeQuarter>
                  <h1>{props.data.contentfulTrader.traderTitle}</h1>
                  <Row>
                    <ThreeQuarter>
                      <div className="content">
                        {/* <span>{props.data.contentfulBlogPost.category}</span> */}
                        {/* <p className="standfirst">
                          {props.data.contentfulBlogPost.standfirst.standfirst}
                        </p> */}
                        {/* <span className="meta">
                          Posted on {props.data.contentfulBlogPost.publishedDate}
                        </span> */}
                        {traderImageGalleryTrue ? (
                          <TraderCarousel>{props.data.contentfulTrader.traderImageGallery.map(photo=>{
                            return <GatsbyImage image={photo.gatsbyImageData} />
                        })}</TraderCarousel>
                        ) : (
                          <GatsbyImage image={props.data.contentfulTrader.traderCoverImage.gatsbyImageData} alt={props.data.contentfulTrader.traderTitle} />
                        )}

                        <Content>
                            <OpeningTimesMobile>
                                  <li>{props.data.contentfulTrader.traderNumber}</li>
                                  <br/>
                                  <li>Opening times</li>
                                  <br/>
                                  <li>{props.data.contentfulTrader.openingTimes.openingTimes}</li>
                                  <br />
                                  <li><Link to="/visiting/#market-map">View Market Map</Link></li>
                            </OpeningTimesMobile>
                            {renderRichText(props.data.contentfulTrader.body, options)}
                        </Content>
                        <Contacts>
                            <Row>
                                <Half>
                                    <div className="left">
                                        <span>Contact details</span>
                                        <ul>
                                            <li>{props.data.contentfulTrader.phone}</li>
                                            {websiteTrue ? (
                                                 <li><a href={props.data.contentfulTrader.website}>View Website</a><LinkIcon />  </li>
                                            ) : null}
                                        </ul>
                                    </div>
                                </Half>
                                <Half>
                                    <div className="right">
                                        <span>Follow elsewhere</span>
                                        <ul>
                                            
                                            {facebookTrue ? (
                                                 <li><a href={props.data.contentfulTrader.facebook}>Facebook</a><LinkIcon />  </li>
                                            ) : null}
                                            {instagramTrue ? (
                                                 <li><a href={props.data.contentfulTrader.instagram}>Instagram</a><LinkIcon />  </li>
                                            ) : null}
                                           
                                        </ul>
                                    </div>
                                </Half>
                            </Row>
                        </Contacts>
                      </div>
                  </ThreeQuarter>
                  <Quarter>
                      <OpeningTimes>
                            <li>{props.data.contentfulTrader.traderNumber}</li>
                            <br/>
                            <li>Opening times</li>
                            <br/>
                            <li>{props.data.contentfulTrader.openingTimes.openingTimes}</li>
                            <br />
                            <li><Link to="/visiting/#market-map">View Market Map</Link></li>
                      </OpeningTimes>
                  </Quarter>
                  </Row>
                </ThreeQuarter>
              </Row>
          </Container>
        </Section>
    </Layout>
  );
};

export default TraderPost;
